import React from 'react';
import { Label } from 'fw/components';
import { Form, TextAreaBox } from 'fw/forms';
import { Col, Modal, Row, Button } from 'react-bootstrap';

class ForceSubmissionPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,

            saving: false,
            loadingForceSubmitData: false,
            buttons: {
                saveForceSubmit: { disabled: false },
            },
            form: {
                forceSubmitReason: null,
            },
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            saving: false,
        });
    }

    saveForceSubmit = () => {
        if (!this._form.validate())
            return;

        const me = this;

        this.setState({
            saving: true
        }, function () {
            me.props.onSave(me.state.form.forceSubmitReason);
            me.close();
        });
    }

    close = () => {
        this.setState(this.initialState(this.props), function () {
            this.props.onClose();
        });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    renderCommentsSection() {
        let title = (
            <Row>
                <Col md={12}>
                    <Label htmlFor="forceSubmitReason" required>Enter the reason for this Submit.-</Label>
                </Col>
            </Row>
        );

        return (
            <React.Fragment>
                {title}
                <Row>
                    <Col md={12}>
                        <TextAreaBox 
                            name="forceSubmitReason"
                            placeholder="Enter your comments here..."
                            maxLength={200}
                            rows={4}
                            required />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <Modal.Title>Force Submission Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onChange={this.handleChange}
                        values={this.state.form}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col md={12}>
                                You are about to force the submission of this Application.<br />
                            </Col>
                        </Row>
                        {this.renderCommentsSection()}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                    <Button bsStyle="primary" disabled={this.state.saving} onClick={this.saveForceSubmit}>Force Submission</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ForceSubmissionPopup;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/ForceSubmissionPopup.js